import {Drawer} from "@mui/material";
import {createModal, destroyModal} from "../../utils/modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark, faCookieBite, faWifi} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import {
  faFacebook,
  faFoursquare,
  faInstagram,
  faTiktok,
  faTwitter,
  faYoutube
} from "@fortawesome/free-brands-svg-icons";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

const HomeInfoModal = () => {
  const {menuInfo} = useSelector(state => state.app)
  const {t} = useTranslation();
  const socialMap = {
    facebook: {icon: faFacebook, link: 'https://www.facebook.com/'},
    twitter: {icon: faTwitter, link: 'https://www.twitter.com/'},
    instagram: {icon: faInstagram, link: 'https://www.instagram.com/'},
    youtube: {icon: faYoutube, link: 'https://www.youtube.com/@'},
    tiktok: {icon: faTiktok, link: 'https://www.tiktok.com/@'},
    foursquare: {icon: faFoursquare, link: 'https://www.foursquare.com/v/'},
  }


  const goToSocialLink = (platform, accountName) => {
    window.open(socialMap[platform].link + accountName, '_blank');
  }

  return (
    <>
      {
        <Drawer
          PaperProps={{
            sx: {
              backgroundColor: "transparent",
              boxShadow: 'none'
            }
          }}
          anchor={'bottom'}
          open={true}
          onClose={destroyModal}
        >

          <div className={'w-full max-w-[420px] mx-auto bg-[#fff] h-[350px] rounded-t-[30px] p-4 relative'}>
            <FontAwesomeIcon icon={faCircleXmark} size={'2x'}
                             className={'image-text-primary w-[40px] h-[40px] absolute'} style={{right: 5, top: 5}}
                             onClick={destroyModal}/>

            <div className={'overflow-scroll no-scrollbar grid grid-cols-2 h-[300px] gap-2 pb-6 mt-6'}>

              <div onClick={() => createModal('cookie_preferences')}
                   className={'h-[140px] overflow-hidden py-3 rounded-[10px] bg-[#f8f8f9] flex flex-col justify-center items-center m-2 shadow-md'}>
                <div
                  className={'image-bg-primary w-[55px] h-[55px] p-2 rounded-full mb-2 flex justify-center items-center'}>
                  <FontAwesomeIcon icon={faCookieBite} size={'2x'} color={'#fff'}/>
                </div>
                <div className={'text-[#555] text-center'}>{t('menu.cookie_preferences')}</div>
              </div>
              {
                menuInfo?.wifi?.ssid && menuInfo?.wifi?.password && (
                  <div onClick={() => createModal('wifi_modal')}
                       className={'h-[140px] overflow-hidden py-3 rounded-[10px] bg-[#f8f8f9] flex flex-col justify-center items-center m-2 shadow-md'}>
                    <div
                      className={'image-bg-primary w-[55px] h-[55px] p-2 rounded-full mb-2 flex justify-center items-center'}>
                      <FontAwesomeIcon icon={faWifi} size={'2x'} color={'#fff'}/>
                    </div>
                    <div className={'text-[#555] text-center'}>{t('menu.wifi')}</div>
                  </div>
                )
              }
              {
                menuInfo && menuInfo?.social_media && (
                  Object.entries(menuInfo?.social_media).map(([socialPlatform, accountName], index) => {
                    return (
                      <>
                        {
                          socialPlatform && accountName &&
                          <div key={`${socialPlatform}-modal`}
                               onClick={() => goToSocialLink(socialPlatform, accountName)}>
                            <div
                              className={'h-[140px] overflow-hidden py-3 rounded-[10px] bg-[#f8f8f9] flex flex-col justify-center items-center m-1 shadow-md'}>

                              <div
                                className={'image-bg-primary w-[55px] h-[55px] p-2 rounded-full mb-2 flex justify-center items-center'}>
                                {
                                  <FontAwesomeIcon icon={socialMap[socialPlatform].icon} size={'2x'} color={'#fff'}/>
                                }
                              </div>
                              <div className={'text-[#555] text-center'}>/{socialPlatform}</div>
                            </div>
                          </div>
                        }
                      </>
                    )
                  })
                )
              }

            </div>
          </div>
        </Drawer>
      }
    </>
  )
}


export default HomeInfoModal;
